// import axios from 'axios'
import requests from '../utils/request'

// 轮播图
export const getBanner = ()=>{
    return requests({
        url:'/buyer/index/banner',
        method:'get',
    })
}



// 主页实力工厂
export const getFactory = (data)=>{
    console.log
    return requests({
        url:`/buyer/index/factory/list?category=${data}`,
        method:'get',
    })
}

// 主页优秀品牌 
export const getBrandList = ()=>{
    return requests({
        url:'/buyer/index/brand/list',
        method:'get',
    })
}
// 主页优选产品  
export const getProducts = ()=>{
    return requests({
        url:'/buyer/index/products/list',
        method:'get',
    })
}

// 首页咨询  /buyer/index/news/list
export const getNewsList = ()=>{
    return requests({
        url:'/buyer/index/news/list',
        method:'get',
    })
}

// 搜索  /buyer/index/search
export const getSearch = ()=>{
    return requests({
        url:'/buyer/index/search',
        method:'get',
    })
}

// 应急措施
// export const getMock = ()=>{
//     return new Promise ((resolve, reject) =>{
//         setTimeout (
//            ()=>resolve({
//                 // 主页所需要的静态内容 
//            }),1000
//         );
//     }) 
// }

// 分类
export const getheadList = (data={})=>{
    return requests({
        url:'/buyer/index/parts/category/list',
        method:'post',
        data
    })
}

// 类别图片

export const getmap = ()=>{
    return requests({
        url:'/buyer/index/parts/category/map',
        method:'get',
    })
}

